<form #currentForm="ngForm" novalidate>
  <div style="min-height: 500px" class="container-fluid py-5 bg-white px-3 tab-content-border">
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-6">
        <div [class]="'form-group' + (formSubmitted && selectedFiles.length < 1 ? ' has-danger' : '')">
          <div *ngIf="!resettingForm">
            <div class="drop-zone"
                 ng2FileDrop
                 [uploader]="uploader"
                 [ngClass]="{ 'drop-zone-over': hasDropZoneOver, 'drop-zone-has-file': selectedFiles.length > 0, 'drop-zone-invalid': formSubmitted && selectedFiles.length < 1 }"
                 (fileOver)="hasDropZoneOver = $event"
                 (dragover)="onDragOver($event)"
                 (drop)="onNativeDrop($event)"
                 (dragleave)="hasDropZoneOver = false">
              <div *ngIf="selectedFiles.length === 0" class="drop-zone-content">
                <i class="fas fa-cloud-upload-alt fa-3x text-muted mb-2"></i>
                <p class="mb-1">Drag & drop files here</p>
                <p class="text-muted small mb-2">or</p>
                <label class="btn btn-outline-primary btn-sm mb-0">
                  Browse Files
                  <input type="file" class="d-none" multiple (change)="onFilesSelected($event)" />
                </label>
                <p class="text-muted small mt-2 mb-0">Multiple PDFs or images will be merged into one file</p>
              </div>
              <div *ngIf="selectedFiles.length > 0" class="drop-zone-content w-100">
                <div class="file-list w-100">
                  <table class="table table-sm table-borderless mb-2">
                    <tbody>
                      <tr *ngFor="let file of selectedFiles; let i = index" class="file-row">
                        <td class="align-middle" style="width: 30px">
                          <span class="text-muted small">{{ i + 1 }}.</span>
                        </td>
                        <td class="align-middle">
                          <i class="fas fa-file-pdf text-danger mr-1" *ngIf="file.type === 'application/pdf'"></i>
                          <i class="fas fa-file-image text-info mr-1" *ngIf="file.type !== 'application/pdf'"></i>
                          {{ file.name }}
                        </td>
                        <td class="align-middle text-muted small" style="width: 70px">{{ formatFileSize(file.size) }}</td>
                        <td class="align-middle text-right text-nowrap" style="width: 90px">
                          <button type="button" class="btn btn-link btn-sm p-0 mr-1" [disabled]="i === 0" (click)="moveFile(i, -1)" title="Move up">
                            <i class="fas fa-arrow-up"></i>
                          </button>
                          <button type="button" class="btn btn-link btn-sm p-0 mr-1" [disabled]="i === selectedFiles.length - 1" (click)="moveFile(i, 1)" title="Move down">
                            <i class="fas fa-arrow-down"></i>
                          </button>
                          <button type="button" class="btn btn-link btn-sm p-0 text-danger" (click)="removeFileAt(i)" title="Remove">
                            <i class="fas fa-times"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="d-flex justify-content-between align-items-center px-2">
                    <span class="text-muted small">
                      {{ selectedFiles.length }} {{ selectedFiles.length === 1 ? 'file' : 'files' }} &middot; {{ formatFileSize(getTotalSize()) }}
                      <span *ngIf="selectedFiles.length > 1 && canMergeFiles()" class="text-success ml-1">
                        <i class="fas fa-check-circle"></i> Will merge into one PDF
                      </span>
                      <span *ngIf="selectedFiles.length > 1 && !canMergeFiles()" class="text-warning ml-1">
                        <i class="fas fa-exclamation-triangle"></i> Non-PDF/image files cannot be merged
                      </span>
                    </span>
                    <div>
                      <label class="btn btn-outline-secondary btn-sm mb-0 mr-1">
                        Add More
                        <input type="file" class="d-none" multiple (change)="onFilesSelected($event)" />
                      </label>
                      <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeAllFiles()">Clear All</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="invalid-feedback" [ngClass]="{ 'd-block': formSubmitted && selectedFiles.length < 1 }" *ngIf="formSubmitted && selectedFiles.length < 1">No file selected - please select a file</div>
        </div>
        <div class="form-group">
          <label class="form-control-label">Alternate file name</label>
          <input type="text" class="form-control" name="name" [(ngModel)]="doc.name" />
          <small class="form-text text-muted">Leave blank for automatic name</small>
        </div>
        <div [class]="'form-group' + (!doc.document_type_id && formSubmitted ? ' has-danger' : '')">
          <label class="form-control-label">Document Type</label>
          <app-document-type-tree-select
            [placeholder]="'Filter document types'"
            [maxHeight]="300"
            [documentTypeId]="doc.document_type_id"
            (document_type_id)="doc.document_type_id = $event"
            (clearDocumentType)="clearDocumentType()"></app-document-type-tree-select>
          <div class="invalid-feedback" [ngClass]="{ 'd-block': formSubmitted && !doc.document_type_id }">Document type not selected</div>
        </div>
        <div [class]="'form-group' + (authors.length < 1 ? ' has-danger' : '')">
          <label class="form-control-label">Author(s)</label>
          <app-contact-search [select_only]="true" [include_item]="true" (contact)="onAuthorSelect($event)"></app-contact-search>
          <div class="invalid-feedback" [ngClass]="{ 'd-block': formSubmitted && authors.length < 1 }">Atleast one author should be present</div>
          <app-badge badgeType="primary" classes="mt-1 ml-1 mb-1">
            &nbsp;{{ authors.length }} {{ authors.length == 1 ? 'author' : 'authors' }}&nbsp;
          </app-badge>
          <table class="table table-sm">
            <tbody>
              <tr *ngFor="let author of authors; let i = index">
                <td>{{ author.label }}</td>
                <td>
                  <a href="javascript: void(0)" (click)="removeAuthor(i)" class="text-danger">
                    <i class="fas fa-times"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group">
          <label class="form-control-label">Author Date</label>
          <app-datetime-picker [datetime]="doc.authored_at_struct" [dateStrSeparator]="'/'" [showTimePicker]="false" (ngbResult)="doc.authored_at_struct = $event"></app-datetime-picker>
        </div>
        <div [class]="'form-group' + (!tags_list_field.valid && this.formSubmitted ? ' has-danger' : '')">
          <label class="form-control-label">Tags</label>
          <input type="text" class="form-control" [ngClass]="{ 'is-invalid': formSubmitted && !tags_list }" required name="tags_list" #tags_list_field="ngModel" [(ngModel)]="tags_list" />
          <div class="invalid-feedback">Atleast one tag should be mentioned</div>
        </div>
        <div class="form-group">
          <label class="form-control-label">Notes</label>
          <textarea class="form-control" name="notes" [(ngModel)]="doc.notes"></textarea>
        </div>
        <div class="form-group text-center">
          <button type="button" (click)="uploadDocument(currentForm.form.valid)" [disabled]="formSubmitting || merging" class="btn btn-primary">
            <span *ngIf="merging">Merging files&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
            <span *ngIf="!merging && formSubmitting">Uploading&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
            <span *ngIf="!merging && !formSubmitting">Upload</span>
          </button>
          &nbsp;
          <button type="button" class="btn btn-secondary" [disabled]="formSubmitting || merging" (click)="reset()">Reset</button>
        </div>
      </div>
    </div>
  </div>
</form>
